module.exports = __webpack_public_path__ + "media/images/shared/series/hirai-e1979cb187f17ff13ef5f4edc4c85872.png";